import { useMemo, useRef } from 'react';
// @ts-ignore
import { AngularApp, getAngularRootModule } from '../utils/angularBridge';

export function useAngularEventOn(eventName: string, callback: Function | any): Function {
  const ngUnsubscribe = useRef<Function>();

  const unsubscribe = useRef(() => {
    if (ngUnsubscribe.current) {
      ngUnsubscribe.current();
      ngUnsubscribe.current = undefined;
    }
  });

  useMemo(() => {
    if (AngularApp.scope()) {
      // @ts-ignore
      ngUnsubscribe.current = AngularApp.scope().$on(eventName, callback);
    } else {
      getAngularRootModule().run(['$rootScope', function($rootScope: any) {
        ngUnsubscribe.current = $rootScope.$on(eventName, callback);
      }]);
    }
    // eslint-disable-next-line
  }, [1]);

  return unsubscribe.current;
}
